module.exports = __webpack_public_path__ + "stateStreet.90efab0ec3f0c93a785108f02948acee.svg";